// LMSocialForm.js
import React, { useState, useMemo, useEffect } from "react";
import { useEtatGlobal } from "../../../EtatGlobal.js";
// import { IoSearchSharp } from "react-icons/io5";
import { User, Building2, ChevronDown, Check, Percent } from "lucide-react";
import { Input } from "../../../../components/ui/input.js";
import CabinetSelect from "../../components/CabinetSelect";
import SelectOuAutre from "../../components/SelectOuAutre";
import { CIVILITE_OPTIONS } from "../../components/lmSelectOptions";

// Taux de TVA proposes par defaut (boutons rapides) — un taux different peut
// etre saisi librement via "Autre", voir tvaCustomMode plus bas.
const TVA_PRESETS = [8.5, 20];

const formatMontant = (n) =>
  n.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// "20%" ou "8,5%" plutot que "20,00%" — pas de decimales inutiles pour un
// taux affiche tel quel dans le Word (voir tva_taux_libelle).
const formatTauxLabel = (n) => {
  const str = n % 1 === 0 ? String(n) : String(n).replace(".", ",");
  return `${str}%`;
};

function LMLogiciel({
  handleInputChange,
  setDetailsMission,
  setDetailsHonoraire,
}) {
  // const [numSiret, setNumSiret] = useState("");
  // const [isLoading, setIsLoading] = useState(false);

  const [isOpen, setIsOpen] = useState(true);
  const [visible1, setVisible1] = useState(true);

  // const handleNumSiretChange = (e) => {
  //   setNumSiret(e.target.value);
  // };

  // const handleSearchSiret = async () => {
  //   if (numSiret.length !== 14) {
  //     dialog.alert("Le numéro SIRET doit contenir 14 chiffres.");
  //     return;
  //   }

  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `https://backend-myalfa.vercel.app/api/siret/${numSiret}`
  //     );
  //     const data = await response.json();
  //     if (data.success) {
  //       const {
  //         siren,
  //         denominationUniteLegale,
  //         sexeUniteLegale,
  //         adresse,
  //         nomUniteLegale,
  //         prenomUsuelUniteLegale,
  //       } = data;

  //       setFormData((prev) => ({
  //         ...prev,
  //         siren: siren || "",
  //         nom_client: denominationUniteLegale || "",
  //         adresse: adresse
  //           ? `${adresse.numeroVoie || ""} ${adresse.typeVoie || ""} ${
  //               adresse.libelleVoie || ""
  //             }, ${adresse.codePostal || ""} ${adresse.libelleCommune || ""}`
  //           : "",
  //         nom: nomUniteLegale || "",
  //         prenom: prenomUsuelUniteLegale || "",
  //         civilite_lm: sexeUniteLegale === "F" ? "Madame" : "Monsieur",
  //       }));
  //     } else {
  //       dialog.alert("Aucune donnée trouvée pour ce numéro SIRET.");
  //     }
  //   } catch (error) {
  //     console.error("Erreur lors de la recherche SIRET :", error);
  //     dialog.alert("Erreur lors de la recherche. Vérifiez le serveur.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const { formData, setFormData } = useEtatGlobal();

  // Mode de saisie du taux de TVA : boutons rapides (8,5% / 20%) ou taux
  // libre. Initialise sur "vrai" si un taux deja enregistre (formData,
  // reouverture d'une LM en cours) ne correspond a aucun des deux presets.
  const [tvaCustomMode, setTvaCustomMode] = useState(
    () =>
      formData.tva_taux != null &&
      !TVA_PRESETS.includes(Number(formData.tva_taux))
  );

  // Recalcule le montant de TVA et le total TTC des que le taux ou le tarif
  // HT choisi change — remplace les montants autrefois figes a 8,5% dans
  // chaque tuile de tarif (voir onChange des radios plus bas). tva_taux_libelle
  // est le texte pret a inserer dans le Word partout ou le taux est affiche
  // (ex: l'entete de colonne "TVA (8,5%)", jusqu'ici en dur dans le template).
  useEffect(() => {
    const prixHT = parseFloat(
      String(formData.details_tarif_prix || "").replace(",", ".")
    );
    if (!formData.details_tarif_prix || Number.isNaN(prixHT)) return;
    if (formData.tva_taux === "") return;

    const taux = Number(formData.tva_taux ?? 8.5);
    if (Number.isNaN(taux)) return;

    const montantTva = prixHT * (taux / 100);
    const montantTotal = prixHT + montantTva;
    const tvaLibelle = formatTauxLabel(taux);
    const tvaAmount = formatMontant(montantTva);
    const totalAmount = formatMontant(montantTotal);

    if (
      formData.tva_taux === taux &&
      formData.tva_taux_libelle === tvaLibelle &&
      formData.details_tarif_prix_tva === tvaAmount &&
      formData.details_tarif_prix_total === totalAmount
    ) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      tva_taux: taux,
      tva_taux_libelle: tvaLibelle,
      details_tarif_prix_tva: tvaAmount,
      details_tarif_prix_total: totalAmount,
    }));
  }, [
    formData.details_tarif_prix,
    formData.tva_taux,
    formData.tva_taux_libelle,
    formData.details_tarif_prix_tva,
    formData.details_tarif_prix_total,
    setFormData,
  ]);

  console.log("FormData dans LMLogiciel :", formData.details_tarif);

  const isValid = useMemo(() => {
    // liste des champs à vérifier
    // "adresse" n'est pas obligatoire — nullable, laissée vide dans le LM
    // généré si non renseignée.
    const requiredFields = [
      "nom_client",
      "lieu_collab",
      "acticite_principale",
      "effectif",
      "volumes_annuels",
      "nom",
      "prenom",
      "email",
      "telephone",
    ];

    // retourne true seulement si tous les champs sont remplis (non vides)
    return requiredFields.every((field) => {
      const value = formData[field];
      return (
        value !== " " && value !== null && value !== undefined && value !== ""
      );
    });
  }, [formData]);

  useEffect(() => {
    if (isValid) {
      setDetailsMission(true);
    } else {
      setDetailsMission(false); // facultatif si tu veux réinitialiser quand invalide
    }
  }, [isValid, setDetailsMission]);

  useEffect(() => {
    if (isValid) {
      setDetailsHonoraire(true);
    } else {
      setDetailsHonoraire(false); // facultatif si tu veux réinitialiser quand invalide
    }
  }, [isValid, setDetailsHonoraire]);

  // Style commun à toutes les tuiles d'offre (disposition 2 / 2 / 1)
  const tuileStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#840040",
    color: "white",
    padding: "10px",
    paddingRight: "35px",
    borderRadius: "15px",
    justifyContent: "start",
    width: "45%",
    textAlign: "start",
    boxSizing: "border-box",
  };

  return (
    <div className="Container">
      <div>
        <div
          className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
          style={{ padding: "10px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div
              style={{
                display: "flex",
                gap: "25px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                  isValid
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-slate-100 text-slate-600"
                }`}
              >
                {isValid ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <Building2 className="w-5 h-5" />
                )}
              </div>

              <h3
                className="font-semibold text-slate-800"
                style={{ margin: 0 }}
              >
                1. Votre entité
              </h3>
            </div>
            <ChevronDown
              className={`w-5 h-5 text-slate-400 transition-transform ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          </div>
          {isOpen && (
            <div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="p-6 pt-0 space-y-6"
            >
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="grid grid-cols-1 gap-4">
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Nom du client
                      </label>
                      <Input
                        type="text"
                        name="nom_client"
                        value={formData.nom_client}
                        onChange={handleInputChange}
                        required
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    {/* <div
                    className="siret-search"
                    style={{
                      display: "flex",
                      gap: "20px",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Recherche Siret</label>
                      <input
                        type="text"
                        name="NumSiret"
                        value={numSiret}
                        onChange={handleNumSiretChange}
                        required
                      />
                    </div>

                    <div
                      onClick={handleSearchSiret}
                      disabled={isLoading}
                      style={{
                        marginTop: "7.5%",
                        color: "white",
                        background: "#840040",
                        padding: "2px 7.5px",
                        borderRadius: "4px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {isLoading ? (
                        <div
                          style={{
                            color: "white",
                            width: "10px",
                            height: "10px",
                            border: "2px solid #ccc",
                            borderTop: "2px solid #007BFF",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        />
                      ) : (
                        <IoSearchSharp size={12} />
                      )}
                    </div>
                  </div> */}
                  </div>
                  <CabinetSelect />
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Adresse
                    </label>
                    <Input
                      type="text"
                      name="adresse"
                      value={formData.adresse}
                      onChange={handleInputChange}
                      className="bg-white border-slate-200 h-9 text-sm"
                    />
                  </div>
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      SIREN
                    </label>
                    <Input
                      type="text"
                      name="siren"
                      value={formData.siren}
                      maxLength="9"
                      onChange={handleInputChange}
                      className="bg-white border-slate-200 h-9 text-sm"
                    />
                  </div>
                </div>

                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <h4 className="font-semibold text-slate-700 mb-5 text-sm flex items-center gap-2">
                    <User className="w-4 h-4 text-[#8B1D41]" />
                    Contact Référent
                  </h4>
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="text-slate-600 mb-1 block text-xs">
                          Civilité
                        </label>
                        <SelectOuAutre
                          name="civilite_lm"
                          value={formData.civilite_lm}
                          onChange={handleInputChange}
                          options={CIVILITE_OPTIONS}
                        />
                      </div>
                      <div>
                        <label className="text-slate-600 mb-1 block text-xs">
                          Nom
                        </label>
                        <Input
                          type="text"
                          name="nom"
                          value={formData.nom}
                          onChange={handleInputChange}
                          className="bg-white border-slate-200 h-9 text-sm"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Prénom
                      </label>
                      <Input
                        type="text"
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Email
                      </label>
                      <Input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Téléphone
                      </label>
                      <Input
                        type="text"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <br />
      <div
        className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
          onClick={() => setVisible1(!visible1)}
        >
          <div
            style={{
              display: "flex",
              gap: "25px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-colors bg-slate-100 text-slate-600">
              <Building2 className="w-5 h-5" />
            </div>
            <h3 className="font-semibold text-slate-800" style={{ margin: 0 }}>
              OFFRE DE TARIF
            </h3>
          </div>
          <ChevronDown
            className={`w-5 h-5 text-slate-400 transition-transform ${
              visible1 ? "rotate-180" : ""
            }`}
          />
        </div>
        {visible1 && (
          <div
            style={{
              display: "flex",
              gap: "20px",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "stretch",
              justifyContent: "center",
            }}
          >
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="CLASSIQUE"
                checked={formData.tarif === "CLASSIQUE" || !formData.tarif}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "CLASSIQUE",
                    details_tarif: `Mon Expert en Gestion (MEG) – Full Web – 1 Utilisateur -
Modules :
-      DEVIS / FACTURATION
Sans engagement`,
                    details_tarif_prix: "15,00",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  MEG CLASSIQUE
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 15,00 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="PREMIUM"
                checked={formData.tarif === "PREMIUM"}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "PREMIUM",
                    details_tarif: `Mon Expert en Gestion (MEG) – Full Web – 1 Utilisateur -
Modules :
-      ACHATS (y compris options SCAN/OCR)
-      DEVIS / FACTURATION
-      BANQUE (synchronisation bancaire)
-      TABLEAU DE BORD
Sans engagement`,
                    details_tarif_prix: "39,90",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  MEG PREMIUM
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 39,90 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="MEG PREMIUM *"
                checked={formData.tarif === "MEG PREMIUM *"}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "MEG PREMIUM *",
                    details_tarif: `Mon Expert en Gestion (MEG) – Full Web – 1 Utilisateur -
Modules :
-      ACHATS (y compris options SCAN/OCR)
-      DEVIS / FACTURATION
-      BANQUE (synchronisation bancaire)
-      TABLEAU DE BORD
Sans engagement`,
                    details_tarif_prix: "29,90",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  MEG PREMIUM *
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 29,90 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="MEG PREMIUM **"
                checked={formData.tarif === "MEG PREMIUM **"}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "MEG PREMIUM **",
                    details_tarif: `Mon Expert en Gestion (MEG) – Full Web – 1 Utilisateur -
Modules :
-      ACHATS (y compris options SCAN/OCR)
-      DEVIS / FACTURATION
-      BANQUE (synchronisation bancaire)
-      TABLEAU DE BORD
Sans engagement`,
                    details_tarif_prix: "35,00",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  MEG PREMIUM **
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 35,00 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="MEG PREMIUM ***"
                checked={formData.tarif === "MEG PREMIUM ***"}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "MEG PREMIUM ***",
                    details_tarif: `Mon Expert en Gestion (MEG) – Full Web – 1 Utilisateur -
Modules :
-      ACHATS (y compris options SCAN/OCR)
-      DEVIS / FACTURATION
-      BANQUE (synchronisation bancaire)
-      TABLEAU DE BORD
Sans engagement`,
                    details_tarif_prix: "19,90",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  MEG PREMIUM ***
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 19,90 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="DEXT CLASSIQUE"
                checked={formData.tarif === "DEXT CLASSIQUE" || !formData.tarif}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "DEXT CLASSIQUE",
                    details_tarif: `DEXT – Full Web – 1 Utilisateur -
Modules :
-      ACHATS (y compris options SCAN/OCR)
-      DEVIS / FACTURATION
Sans engagement`,
                    details_tarif_prix: "19,90",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  DEXT CLASSIQUE
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 19,90 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="DEXT CLASSIQUE *"
                checked={formData.tarif === "DEXT CLASSIQUE *"}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "DEXT CLASSIQUE *",
                    details_tarif: `DEXT – Full Web – 1 Utilisateur -
Modules :
-      ACHATS (y compris options SCAN/OCR)
-      DEVIS / FACTURATION
Sans engagement`,
                    details_tarif_prix: "15,00",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  DEXT CLASSIQUE *
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 15,00 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="DEXT PREMIUM"
                checked={formData.tarif === "DEXT PREMIUM" || !formData.tarif}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "DEXT PREMIUM",
                    details_tarif: `DEXT – Full Web – 1 Utilisateur -
Modules :
-      ACHATS (y compris options SCAN/OCR)
-      DEVIS / FACTURATION
-      BANQUE (synchronisation bancaire)
Sans engagement`,
                    details_tarif_prix: "29,90",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  DEXT PREMIUM
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 29,90 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="DEXT PREMIUM *"
                checked={formData.tarif === "DEXT PREMIUM *"}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "DEXT PREMIUM *",
                    details_tarif: `DEXT – Full Web – 1 Utilisateur -
Modules :
-      ACHATS (y compris options SCAN/OCR)
-      DEVIS / FACTURATION
-      BANQUE (synchronisation bancaire)
Sans engagement`,
                    details_tarif_prix: "35,00",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  DEXT PREMIUM *
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 35,00 € HT / mois
                </p>
              </div>
            </div>
            <div style={tuileStyle}>
              <input
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "25px",
                  marginLeft: "25px",
                }}
                type="radio"
                name="tarif"
                value="I SUITE EXPERT"
                checked={formData.tarif === "I SUITE EXPERT"}
                onChange={() => {
                  setFormData((prev) => ({
                    ...prev,
                    tarif: "I SUITE EXPERT",
                    details_tarif: `I SUITE EXPERT – Full Web – 1 Utilisateur -
Modules :
-      Option compta +
Sans engagement`,
                    details_tarif_prix: "49,90",
                  }));
                }}
              />
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  I SUITE EXPERT
                </p>
                <p style={{ margin: 0, fontSize: "10px" }}>
                  tarif de 49,90 € HT / mois
                </p>
              </div>
            </div>
          </div>
        )}
        <br />
      </div>
      <br />
      <div
        className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            gap: "25px",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
          className="p-4"
        >
          <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-colors bg-slate-100 text-slate-600">
            <Percent className="w-5 h-5" />
          </div>
          <h3 className="font-semibold text-slate-800" style={{ margin: 0 }}>
            TAUX DE TVA
          </h3>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "0 15px 15px 15px",
          }}
        >
          {TVA_PRESETS.map((preset) => {
            const active =
              !tvaCustomMode && Number(formData.tva_taux ?? 8.5) === preset;
            return (
              <button
                key={preset}
                type="button"
                onClick={() => {
                  setTvaCustomMode(false);
                  setFormData((prev) => ({ ...prev, tva_taux: preset }));
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: active ? "2px solid #840040" : "1px solid #cbd5e1",
                  backgroundColor: active ? "#840040" : "white",
                  color: active ? "white" : "#334155",
                  fontWeight: active ? "bold" : "normal",
                  cursor: "pointer",
                }}
              >
                {formatTauxLabel(preset)}
              </button>
            );
          })}
          <button
            type="button"
            onClick={() => setTvaCustomMode(true)}
            style={{
              padding: "8px 16px",
              borderRadius: "8px",
              border: tvaCustomMode ? "2px solid #840040" : "1px solid #cbd5e1",
              backgroundColor: tvaCustomMode ? "#840040" : "white",
              color: tvaCustomMode ? "white" : "#334155",
              fontWeight: tvaCustomMode ? "bold" : "normal",
              cursor: "pointer",
            }}
          >
            Autre
          </button>
          {tvaCustomMode && (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <input
                type="number"
                step="0.01"
                min="0"
                placeholder="Taux %"
                value={formData.tva_taux ?? ""}
                onChange={(e) => {
                  const val = e.target.value;
                  setFormData((prev) => ({
                    ...prev,
                    tva_taux: val === "" ? "" : Number(val),
                  }));
                }}
                style={{
                  width: "80px",
                  padding: "8px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                }}
              />
              <span>%</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LMLogiciel;
